import { APIFunctionName } from "./APIFunctionName";
import { APIInputData } from "./APIInputData";
import { PHPRequest } from "../PHPRequest";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPContext } from "../PHPContext";
import { PHPResponse } from "../PHPResponse";

export abstract class APIRequest<A,I extends APIInputData, O extends PHPResponse> extends PHPRequest<PHPAdress,I,O>
{
  private _api;

  constructor( api:APIFunctionName)
  {
    super( PHPAdresses.API );
    this._api = api;
  }

  async call( phpContext:PHPContext, input:I, logResponse:boolean = true ):Promise<void>
  {
    input.api = this._api;
    
    await super.call( phpContext, input, logResponse );    

    return Promise.resolve();
  }

  request( phpContext:PHPContext, input:I, logResponse:boolean = false ):Promise<O>
  {
    input.api = this._api;
    let promise = super.request( phpContext, input, logResponse );    

    return Promise.resolve( promise );
  }
} 